/**
 * Couleurs d'univers des produits, reprises de finance-for-you.com (direction « Univers ») :
 * fond clair (tint) + texte foncé (deep, ≥ 4,5:1). Un produit garde la même couleur partout.
 */
const SANTE = 'bg-sante-tint text-sante-deep border-sante-tint';
const EMPRUNTEUR = 'bg-emprunteur-tint text-emprunteur-deep border-emprunteur-tint';
const AUTO = 'bg-auto-tint text-auto-deep border-auto-tint';
const MOTO = 'bg-moto-tint text-moto-deep border-moto-tint';
const HABITATION = 'bg-habitation-tint text-habitation-deep border-habitation-tint';
const ANIMAL = 'bg-animal-tint text-animal-deep border-animal-tint';
const PRO = 'bg-pro-tint text-pro-deep border-pro-tint';
const PREVOYANCE = 'bg-prevoyance-tint text-prevoyance-deep border-prevoyance-tint';

export const PRODUCT_UNIVERS_STYLES: Record<string, string> = {
  sante: SANTE,
  expatrie: SANTE,
  emprunteur: EMPRUNTEUR,
  auto: AUTO,
  vsp: AUTO,
  vtc: AUTO,
  moto: MOTO,
  habitation: HABITATION,
  pno: HABITATION,
  animal: ANIMAL,
  pro: PRO,
  rc_pro: PRO,
  prevoyance: PREVOYANCE,
  per: PREVOYANCE,
  scolaire: PREVOYANCE,
};

/** Couleur vive de l'univers d'un produit (graphiques), gris si le produit n'a pas d'univers. */
const VIVID: Record<string, string> = {
  sante: '#E74C8B', expatrie: '#E74C8B',
  emprunteur: '#7B61FF',
  auto: '#FFCD27', vsp: '#FFCD27', vtc: '#FFCD27',
  moto: '#FF8A3D',
  habitation: '#30A6DC', pno: '#30A6DC',
  animal: '#3DBE6E',
  pro: '#032040', rc_pro: '#032040',
  prevoyance: '#2BB3A8', per: '#2BB3A8', scolaire: '#2BB3A8',
};
export const productVivid = (productType: string) => VIVID[productType] ?? '#94A3B8';
